import { render } from "./EnrollmentsView.vue?vue&type=template&id=1987c6ac&scoped=true&ts=true"
import script from "./EnrollmentsView.vue?vue&type=script&lang=ts"
export * from "./EnrollmentsView.vue?vue&type=script&lang=ts"

import "./EnrollmentsView.vue?vue&type=style&index=0&id=1987c6ac&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1987c6ac"]])

export default __exports__